import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges class names, with later Tailwind utilities winning over earlier ones.
 *
 * `clsx` alone is not enough: `clsx("p-2", "p-4")` yields "p-2 p-4" and which one
 * applies then depends on CSS source order, not on the caller's intent. `twMerge`
 * resolves the conflict so a component's own padding can always be overridden by a
 * `className` prop — which is the entire reason these components accept one.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
